<template functional>
  <div class="withdraw-state-label-wrapper">
    <!-- <template v-if="props.status === $options.status().ING">
      <div class="state-label" style="background-color:#dadde0;">
        <i class="el-icon-circle el-icon-remove-outline"></i>
      </div>
      <span style="color:#dadde0">提现中</span>
    </template> -->
    <template v-if="props.status === $options.status().TRANSFERRED">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
      <span style="color:#005bff">{{ $options.status_zh().TRANSFERRED }}</span>
    </template>
    <template v-else-if="props.status === $options.status().TRANSFER_FAILED">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#FF5753"></i>
      <span style="color:#FF5753">{{ $options.status_zh().TRANSFER_FAILED }}</span>
    </template>
    <template v-else-if="props.status === $options.status().REVIEWING">
      <i class="el-icon-circle el-icon-time" style="background-color:#00bd83;"></i>
      <span style="color:#00bd83;">{{ $options.status_zh().REVIEWING }}</span>
    </template>
    <template v-else-if="props.status === $options.status().REVIEWED">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
      <span style="color:#005bff">{{ $options.status_zh().REVIEWED }}</span>
    </template>
    <template v-else-if="props.status === $options.status().REVIEW_FAILED">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#FF5753"></i>
      <span style="color:#FF5753">{{ $options.status_zh().REVIEW_FAILED }}</span>
    </template>
    <template v-else>
      <span>- -</span>
    </template>
  </div>
</template>

<script>
import { STATUS, STATUS_ZH } from '../_eum';
export default {
  name: 'withdrawStateLabel',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  status() {
    return STATUS;
  },
  status_zh() {
    return STATUS_ZH;
  }
};
</script>

<style lang="scss">
.withdraw-state-label-wrapper {
  display: flex;
  align-items: center;
  // i {
  //   font-size: 16px;
  //   padding: 2px;
  //   color: white;
  //   border-radius: 50%;
  // }
}
</style>
